
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useAuth } from "@/contexts/auth";
import { demographicsSchema, DemographicsFormValues } from "./types";

export const useDemographicsForm = () => {
  const { profile, updateDemographics } = useAuth();
  
  const form = useForm<DemographicsFormValues>({
    resolver: zodResolver(demographicsSchema),
    defaultValues: {
      age_group: "",
      gender: "",
      education_level: "",
      employment_status: "",
      political_leaning: "",
      income_range: "",
      residence_type: ""
    },
  });
  
  // Initialize form with existing demographics data when profile loads
  useEffect(() => {
    if (profile?.demographics) {
      const { demographics } = profile;
      form.reset(demographics);
    }
  }, [profile, form]);

  const onSubmit = async (data: DemographicsFormValues) => {
    await updateDemographics(data);
  };

  return {
    form,
    onSubmit,
  };
};
